<template>
  <el-dialog title="消息详情" :visible.sync="dialogVisible" @close="handleClose" width="60vw" class="message-dialog">
    <div class="message-title">{{ detail.businessTypeName }}</div>
    <div class="message-time">{{ detail.createTime ? formatDate(detail.createTime, 'YYYY-MM-DD HH:mm:ss') : '' }}</div>
    <div class="message-remark" v-html="currentContent" @click="handleViewDetail"></div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small" type="primary">我知道了</el-button>
    </span>
  </el-dialog>
</template>
<script>
import * as Moment from 'dayjs';
import { mapMutations } from 'vuex';
import { updateReadFlag, queryCount } from '@/api/messages';
import { inquirePriceDetail } from '@/api/inquiryForm.js';
export default {
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      dialogVisible: false,
    };
  },
  computed: {
    currentContent () {
      let content = this.detail.content;
      return ['ENTERPRISE_TENANT_AUTHENTICATION_AUDIT_REJECT', 'TENANT_INDUSTRY_CAPACITY_AUTH_AUDIT_REJECT', 'INQUIRE_QUOTE_PRICE_BUSINESS_OPPORTUNITY', 'COOPERATION_SUBSCRIPTION_REMIND_ENTERPRISE_AUTHENTICATION', 'COOPERATION_SUBSCRIPTION_OPERATION_REMIND'].includes(this.detail.businessType) ? content.replace(/查看详情/g, '<a class="detailBtn">查看详情</a>').replace(/请先完成企业认证/g, '请先完成<a class="detailBtn">企业认证</a>') : content;
    },
  },
  watch: {
    dialogVisible (v) {
      if (v) {
        updateReadFlag({ id: this.detail.id }).then(() => {
          this.queryMsgCount();
        });
      }
    },
  },
  methods: {
    ...mapMutations({
      updateUnReadCount: 'UPDATE_UNREADCOUNT',
    }),
    formatDate (text, format = 'YYYY-MM-DD') {
      return text ? Moment(text * 1).format(format) : '/';
    },
    handleClose () {
      if (this.dialogVisible) {
        this.$emit('close', 0);
        this.dialogVisible = false;
      }
    },
    async queryMsgCount () {
      const { employeeMsg } = JSON.parse(this.$local.get('userInfo'));
      const remindUserId = employeeMsg.id;
      const data = await queryCount({ readFlag: 0, remindUserId, onTimeRemindFlag: true });
      this.unReadCount = Number(data.body.unReadCount) || 0;
      this.updateUnReadCount(this.unReadCount);
    },
    handleViewDetail (e) {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let target = e.target;
      if (target.className === 'detailBtn') {
        if (['ENTERPRISE_TENANT_AUTHENTICATION_AUDIT_REJECT', 'COOPERATION_SUBSCRIPTION_REMIND_ENTERPRISE_AUTHENTICATION'].includes(this.detail.businessType)) {
          this.$router.push({
            name: 'IDENTIFICATION',
          });
          this.$emit('close', 1);
          this.dialogVisible = false;
        }

        if (['TENANT_INDUSTRY_CAPACITY_AUTH_AUDIT_REJECT'].includes(this.detail.businessType)) {
          this.$router.push({
            name: 'IDENTIFICATION',
          });
          this.$emit('close', 1);
          this.dialogVisible = false;
        }
        if (['COOPERATION_SUBSCRIPTION_OPERATION_REMIND'].includes(this.detail.businessType)) {
          this.$router.push({
            name: 'GONGXUTONG',
          });
          this.$emit('close', 1);
          this.dialogVisible = false;
        }
        if (['INQUIRE_QUOTE_PRICE_BUSINESS_OPPORTUNITY'].includes(this.detail.businessType)) {
          inquirePriceDetail({
            tenantId: userInfo.tenantId,
            id: this.detail.objId,
            findNewestQuoteFlag: false,
            findWorkOrderFlag: false,
            employeeId: userInfo?.employeeMsg?.id || null,
          }).then(({ body }) => {
            this.$router.push({
              name: 'CUSTOMER_INQUIRY_HANDLE',
              query: {
                id: body.id,
                type: body.businessType,
                toTab: body.inquireTenantStatus === 'NEGOTIATING' ? 'price' : null,
              },
            });
            this.$emit('close', 1);
            this.dialogVisible = false;
          });
        }
      }
    },

  },
};
</script>
<style lang="scss" scoped>
.message-dialog {
  .message-title {
    font-weight: 600;
    font-size: 16px;
    color: #1F2733;
    padding: 15px 15px 0;
  }
  .message-time {
    font-weight: 400;
    font-size: 12px;
    color: #929AA6;
    padding: 10px 15px;
  }
  .message-remark {
    height: 50vh;
    overflow-y: scroll;
    padding: 0 15px;
  }
}
</style>
